__turbopack_context__.v({
  "root": "SolidBgTextSection-module__Hqt86G__root",
  "stickyWrapper": "SolidBgTextSection-module__Hqt86G__stickyWrapper",
  "textContent": "SolidBgTextSection-module__Hqt86G__textContent",
});
